const ModalKeys = {
  home_dept_chat_modal: "home_dept_chat_modal",
  home_team_modal: "home_team_modal",
  home_groups_modal: "home_groups_modal",
  //home_feedback_modal: "home_feedback_modal",
  home_products_modal: "home_products_modal",
  home_email_modal: "home_email_modal",
  home_call_modal: "home_call_modal",
  home_social_list_modal: "home_social_list_modal",

  home_guest_products_modal: "home_guest_products_modal",
  home_guest_email_modal: "home_guest_email_modal",
  home_guest_call_modal: "home_guest_call_modal",
  home_guest_social_list_modal: "home_guest_social_list_modal",

  settings_language: "settings_language",
  list_choose_branch: "list_choose_branch",
  preview_image_document: "preview_image_document",
  deactivation_confirm_ask_password: "deactivation_confirm_ask_password",
  deactivation_success_alert: "deactivation_success_alert",
  country_code_selection: "country_code_selection",
  choose_city_of_residence: "choose_city_of_residence",
  choose_country_state_city_area: "choose_country_state_city_area",
  search_filter: "search_filter",
  signup_welcom_message: "signup_welcom_message",
  connect_detail_branch_depts_chat: "connect_detail_branch_depts_chat",
  connect_detail_branch_team: "connect_detail_branch_team",
  work_profile_menu: "work_profile_menu",
  home_guest_general_form: "home_guest_general_form",
  home_guest_feedback_form: "home_guest_feedback_form",
  work_automated_reply: "work_automated_reply",
  work_my_messages: "work_my_messages",

  datepicker: "datepicker",

  image_editor: "image_editor",
  video_editor: "video_editor",

  chat_mute_notification: "chat_mute_notification",
  chat_media: "chat_media",
  chat_report: "chat_report",
  chat_work_my_messages: "chat_work_my_messages",
  chat_group_exit: "chat_group_exit",

  connect_detail_branch_group: "connect_detail_branch_group",
  web_view: "web_view",
  file_document_viewer: "file_document_viewer",
  arf_form: "arf_form",
  connect_detail_branch_depts_restrict: "connect_detail_branch_depts_restrict",
  chat_location: "chat_location",
  chat_delete_message: "chat_delete_message",
  chat_forward: "chat_forward",
  chat_group_info: "chat_group_info",
  chat_delete_message_media: "chat_delete_message_media",
  chat_forward_media: "chat_forward_media",
  chat_camera: "chat_camera",
  chat_preview_image_document: "chat_preview_image_document",

  list_choose_division: "list_choose_division",
};

export default ModalKeys;

